module.exports = __webpack_public_path__ + "static/img/youth.269eb474.svg";